
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequirea579"];
var parcelRegister = parcelRequire.register;
parcelRegister("e8y07", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.init = void 0;
// ====================================================================================
// header.module
// ====================================================================================
var $a4ac2fe66a9543d0$var$header = {
    el: document.querySelector(".header"),
    isMini: false,
    scrollStart: document.querySelector(".banner") ? 99 : 7
};
var $a4ac2fe66a9543d0$var$updateHeaderHeight = function updateHeaderHeight() {
    var headerHeight = $a4ac2fe66a9543d0$var$header.el.offsetHeight;
    document.querySelector("main").style.marginTop = headerHeight + "px";
};
var $a4ac2fe66a9543d0$var$scrollHandler = function scrollHandler() {
    var sc = window.scrollY || window.pageYOffset;
    if (sc > $a4ac2fe66a9543d0$var$header.scrollStart) {
        if ($a4ac2fe66a9543d0$var$header.isMini) return;
        $a4ac2fe66a9543d0$var$header.el.classList.add("header--mini");
        $a4ac2fe66a9543d0$var$header.isMini = true;
    } else if ($a4ac2fe66a9543d0$var$header.el.classList.contains("header--mini")) {
        $a4ac2fe66a9543d0$var$header.el.classList.remove("header--mini");
        $a4ac2fe66a9543d0$var$header.isMini = false;
    }
};
var $a4ac2fe66a9543d0$var$init = module.exports.init = function init() {
    var attempts = 0;
    $a4ac2fe66a9543d0$var$updateHeaderHeight();
    if ((window.scrollY || window.pageYOffset) > 159) $a4ac2fe66a9543d0$var$header.el.classList.add("header--mini");
    // if document.ready needed
    var _whenComplete = function whenComplete() {
        if (attempts > 30) return;
        attempts += 1;
        if (document.readyState === "complete") {
            window.addEventListener("scroll", $a4ac2fe66a9543d0$var$scrollHandler);
            var intervalId = setInterval(function() {
                $a4ac2fe66a9543d0$var$updateHeaderHeight();
            }, 50);
            window.onbeforeunload = function() {
                clearInterval(intervalId);
            };
        } else setTimeout(function() {
            _whenComplete();
        }, 400);
    };
    _whenComplete();
};

});


//# sourceMappingURL=header.module.7eef1267.js.map
